import React from 'react'

const DashboardCard = ({ title, icon: Icon, count }) => {
  return (
    <div className="w-full sm:w-60 h-36 bg-white shadow-md rounded-lg p-4 flex flex-col justify-between items-start">
      <div className="flex items-center gap-3">
        <div className="text-2xl text-orange-500">
          <Icon />
        </div>
        <h3 className="text-lg font-semibold">{title}</h3>
      </div>
      <p className="text-3xl font-bold text-gray-700">{count}</p>
    </div>
  )
}

export default DashboardCard
